import { render } from "./TermsView.vue?vue&type=template&id=20282c82&scoped=true&ts=true"
import script from "./TermsView.vue?vue&type=script&lang=ts"
export * from "./TermsView.vue?vue&type=script&lang=ts"

import "./TermsView.vue?vue&type=style&index=0&id=20282c82&scoped=true&lang=scss"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-20282c82"]])

export default __exports__